import { render, staticRenderFns } from "./DataSourceAttributesEditingTableRow.vue?vue&type=template&id=01b5bc9d&scoped=true&"
import script from "./DataSourceAttributesEditingTableRow.vue?vue&type=script&lang=js&"
export * from "./DataSourceAttributesEditingTableRow.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceAttributesEditingTableRow.vue?vue&type=style&index=0&id=01b5bc9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5bc9d",
  null
  
)

export default component.exports